// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ZZNgq","buttons":"Footer_buttons__dELIw"};